module.exports = __webpack_public_path__ + "img/cardTwoImg.7a97104c.png";